<div class="col-{{ span }}" [class]="backBarConfig.styleClass || 'BACK_BAR'">
  <span>
    <button type="button" class="btn btn-link back-button" (click)="back()">
      <em class="pi pi-chevron-circle-left m-1"></em>
      <span>{{ label }}</span>
    </button>
  </span>
  <hr />
</div>
